import { useState, useEffect } from 'react';
import Link from '@/components/compat/Link';
import { usePathname } from '@/lib/navigation';
import { smileyStripUrl } from '@/components/help-center/latest-power-shared';
import { readCookieConsent } from '@/lib/cookie-consent';

const MESSAGES = [
  <>Precisa de <strong>Ajuda?</strong></>,
  <>Obtenha ajuda com <strong>xat</strong> aqui!</>,
] as const;

function HelpFloatingButtonInner() {
  const [msgIndex, setMsgIndex] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeIn(false);
      const swap = setTimeout(() => {
        setMsgIndex((i) => (i + 1) % MESSAGES.length);
        setFadeIn(true);
      }, 350);
      return () => clearTimeout(swap);
    }, 3800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-[200] flex flex-col items-end gap-2.5">
      <div className="relative">
        <div className="w-max rounded-2xl rounded-br-sm bg-white px-4 py-2.5 shadow-[0_4px_24px_rgba(0,0,0,0.18)] ring-1 ring-black/[0.06]">
          <p
            className="font-poppins text-sm font-normal leading-snug text-gray-800 whitespace-nowrap transition-all duration-300"
            style={{
              opacity: fadeIn ? 1 : 0,
              transform: fadeIn ? 'translateY(0)' : 'translateY(4px)',
            }}
          >
            {MESSAGES[msgIndex]}
          </p>
        </div>
        <div
          className="absolute -bottom-[9px] right-3 h-0 w-0"
          style={{
            borderLeft: '10px solid transparent',
            borderRight: '0px solid transparent',
            borderTop: '10px solid white',
          }}
          aria-hidden
        />
      </div>

      <Link
        href="https://xat.com/Ajuda"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Obter suporte no xat"
        className="group transition-transform duration-200 hover:scale-110 active:scale-95"
      >
        <img
          src={smileyStripUrl('what')}
          alt="Suporte"
          width={64}
          height={64}
          className="h-16 w-16 object-contain transition-transform duration-200 group-hover:rotate-[-8deg]"
          draggable={false}
        />
      </Link>
    </div>
  );
}

export default function HelpFloatingButton() {
  const pathname = usePathname();
  const [consentPending, setConsentPending] = useState(() => readCookieConsent() === null);

  useEffect(() => {
    const sync = () => setConsentPending(readCookieConsent() === null);
    sync();
    window.addEventListener('xat-cookie-consent-changed', sync);
    return () => window.removeEventListener('xat-cookie-consent-changed', sync);
  }, []);

  // Esconde enquanto o banner de cookies está visível (evita overlap nos botões).
  if (consentPending) return null;

  if (pathname?.startsWith('/painel') || pathname?.startsWith('/fairtrade')) {
    return null;
  }
  // Coming soon: sem smiley+balão no mobile (ocupa o ecrã estreito)
  if (pathname?.startsWith('/coming-soon')) {
    return (
      <div className="hidden md:block">
        <HelpFloatingButtonInner />
      </div>
    );
  }
  return <HelpFloatingButtonInner />;
}
